import React from 'react';
import styles from './NumberCard.module.css';

import CountUp from 'react-countup';

const NumberCard = ({ symbol, number, label, ...style }) => {
    return (
        <div className={styles.mainContainer} style={style}>
            <p className={styles.numberContainer}>
                {symbol}
                <CountUp
                    end={number}
                    enableScrollSpy
                />
            </p>
            <p className={styles.labelContainer}>{label}</p>
        </div>
    );
};

export default NumberCard;
